import axios from 'axios'
import { INTERNAL_API_CONFIG } from '@/config/internal-api.config'

// Instância do Axios para API Interna
const axiosInternal = axios.create({
  baseURL: INTERNAL_API_CONFIG.baseURL,
  timeout: INTERNAL_API_CONFIG.timeout,
  headers: {
    ...INTERNAL_API_CONFIG.headers,
    'X-Service-Key': INTERNAL_API_CONFIG.serviceKey,
  },
})

// Interceptor de Request - Adiciona X-User-Id do localStorage
axiosInternal.interceptors.request.use(
  config => {
    // Buscar funcionarioId do localStorage
    const funcionarioId = localStorage.getItem(INTERNAL_API_CONFIG.userIdStorageKey)

    if (funcionarioId) {
      config.headers['X-User-Id'] = funcionarioId
    }

    return config
  },
  error => Promise.reject(error),
)

export default axiosInternal
